import axios from 'axios'

export default class {
  _emailUrl
  _additionalConfig

  constructor() {
    this._emailUrl = `${process.env.VUE_APP_API_PSC_URL}${process.env.VUE_APP_API_PSC_EMAIL}`
    this._additionalConfig = {
      headers: {
        'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`
      }
    }
  }

  sendEmailService(token, data){
    let additionalConfig = {
      headers: {
        'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`,
        'Authorization': `Bearer ${token}`
      }
    }
    return axios.post(`${this._emailUrl}`, data, (token == null ? this._additionalConfig : additionalConfig))
  }
}
